export default __webpack_public_path__ + "static/zerogravity-86172eb035ca71a98d41bd926113a5e2.webp";